import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`
let baseUrl2 = `${httpUrl.host}/gy-lease`
// let baseUrl = '/api/gy-apartment'

let api = {
  // 获取统计数据
  getStatisticsData: `${baseUrl}/homePage/home`,

  // 添加房间
  addRoomInfo: `${baseUrl}/roomInfo/addRoomInfo`,

  // 修改房间
  updateRoomInfo: `${baseUrl}/roomInfo/updateRoomInfo`,

  // 删除楼层
  deleteFloorByCodes: `${baseUrl}/floor/deleteByCodes`,

  // 删除房间
  deleteRoomInfoByCodes: `${baseUrl}/roomInfo/deleteRoomInfoByCodes`,

  // 获取房间分页
  getRoomInfoPage: `${baseUrl}/roomInfo/getRoomInfoPage`,

  // 获取房间列表
  getRoomInfoList: `${baseUrl}/roomInfo/getRoomInfoList`,

  // 获取房间列表
  getRoomInfoListGroupByFloor: `${baseUrl}/roomInfo/getRoomInfoListGroupByFloor`,

  // 获取房源统计
  getRoomStatusNumber: `${baseUrl}/roomInfo/getRoomStatusNumber`,

  // 获取单个房间信息
  getRoomInfoByCode: `${baseUrl}/roomInfo/getRoomInfoByCode`,

  // 导入房间信息
  importRoomInfo: `${baseUrl}/roomInfo/import`,

  // 导出房间信息
  exportRoomInfo: `${baseUrl}/roomInfo/export`,

  // 查询楼栋分页
  getBuildingPage: `${baseUrl}/building/getBuildingPage`,
  // getBuildingPage: `${baseUrl}/building/getBuildingPageByAccountName`,

  // 添加楼栋
  addBuilding: `${baseUrl}/building/addBuilding`,

  // 删除楼栋分页
  deleteBuildingByCodes: `${baseUrl}/building/deleteBuildingByCodes`,

  // 查询楼栋信息
  getBuildingByCode: `${baseUrl}/building/getBuildingByCode`,

  // 获取楼栋列表
  getBuildingList: `${baseUrl}/building/getBuildingList`,
  // getBuildingList: `${baseUrl}/building/getBuildingListByAccountName`,

  // 获取楼栋统计详情
  getBuildingByCodeWithDetail: `${baseUrl}/building/getBuildingByCodeWithDetail`,

  // 修改楼栋信息
  updateBuilding: `${baseUrl}/building/updateBuilding`,

  // 导入楼栋信息
  importBuilding: `${baseUrl}/building/import`,

  // 导出楼栋信息
  exportBuilding: `${baseUrl}/building/export`,

  // 修改楼层面积
  updateFloorArea: `${baseUrl}/floor/updateFloorArea`,

  // 获取当前房源关联的合同信息
  getContractByRoomCode: `${baseUrl2}/contractManager/getContractByRoomCode`,

  // 获取当前房源关联的所有合同信息
  getContractPage: `${baseUrl}/roomInfo/getContractPage`,

  // 获取合同详情
  getContractByCode: `${baseUrl2}/contractManager/getByCode`,

  // 上传图片
  uploadImg: `${baseUrl}/yqNews/uploadImg`,

  // 获取人员列表
  getPersonList: `${baseUrl}/person/getList`,

  // // 添加园区组织
  // addyqInfo: `${baseUrl}/yqTree/addyqInfo`,
  //
  // // 修改园区组织
  // updateyqInfo: `${baseUrl}/yqTree/updateyqInfo`,
  //
  // // 删除园区组织
  // deleteyqInfoByIds: `${baseUrl}/yqTree/deleteyqInfoByIds`,
  //
  // // 获取园区组织列表
  // getYqInfoList: `${baseUrl}/yqTree/getYqInfoList`,
  //
  // // 获取单个园区信息
  // getYqInfoById: `${baseUrl}/yqTree/getYqInfoById`,
  //
  // // 获取子节点列表
  // getYqInfoChildrenById: `${baseUrl}/yqTree/getYqInfoChildrenById`,
  //
  // // 获取所有节点信息
  // getAllChildyqInfoIds: `${baseUrl}/yqTree/getAllChildyqInfoIds`,
  //
  // // 根据ID获取园区子节点信息跟房间信息
  // getYqInfoChildrenAndRoomById: `${baseUrl}/yqTree/getYqInfoChildrenAndRoomById`,

  // 添加房间类型
  addRoomType: `${baseUrl}/roomType/add`,

  // 删除房间类型
  deleteRoomType: `${baseUrl}/roomType/del`,

  // 修改房间类型
  updateRoomType: `${baseUrl}/roomType/update`,

  // 查询房间类型详情
  getRoomTypeByCode: `${baseUrl}/roomType/getByCode`,

  // 查询房间类型分页
  getRoomTypePage: `${baseUrl}/roomType/getPage`,

  // 查询房间类型列表
  getRoomTypeList: `${baseUrl}/roomType/getList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/HousingManagement.js